export default __webpack_public_path__ + "static/media/logo-davinci.971c859c.svg";